import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { promotionClickGoogleTag } from '@utils/analytics.js';
import Link from '../base_link/component';
import './styles/styles.scss';

class TegelGenreBanner extends Component {
  constructor(props) {
    super(props);

    this.pushGoogleTags = this.pushGoogleTags.bind(this);
  }

  get genredata() {
    return this.props.genre || {};
  }

  get url() {
    return (this.props.urlLink || this.genredata.url) || '#';
  }

  get imagePath() {
    return this.props.image;
  }

  get displayName() {
    return this.props.urlText || this.props.name || this.props.displayName;
  }

  get openInNewWindow() {
    return this.props.openInNewWindow;
  }

  getTarget() {
    return (this.openInNewWindow === 'true' ? '_blank' : '_self');
  }

  get promotion() {
    return {
      title: this.genredata ? this.genredata.name : this.props.name,
      name: this.displayName,
      backgroundImage: this.imagePath,
      variant: 'banner',
      'component-type': 'tegel-genre',
      url: this.url,
    };
  }

  pushGoogleTags() {
    this.props.store.pushToDataLayer(promotionClickGoogleTag(this.promotion));
  }

  render() {
    const divClass = 'uitgelicht';
    const pClass = 'content text-border';

    return (

      <div className={`tegel-genre-banner ${divClass}`} onClick={this.pushGoogleTags}>
        <Link href={this.url} target={this.getTarget()}>
          <img src={this.imagePath} alt={this.displayName}></img>
          <p className={pClass}>{this.displayName}</p>
        </Link>
      </div>

    );
  }
}

// proptypes
TegelGenreBanner.propTypes = {
  /**
   * Display name of tegel genre banner
   */
  name: PropTypes.string,
  /**
   * Genre data
   */
  genre: PropTypes.shape({
    /**
     * Url for genre category page
     */
    url: PropTypes.string,
    /**
     * The name of the category
     */
    name: PropTypes.string,
  }),
  /**
   * The image path for the tgel genre banner
   */
  image: PropTypes.string.isRequired,
  /**
   * if urlLink is set it will overwrite the genre.name
   */
  urlLink: PropTypes.string,
  /**
   * if urlText is set it will overwrite genre.url
   */
  urlText: PropTypes.string,
  /**
   * Boolean, if set to true the link will have target="_blank"
   */
  openInNewWindow: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]),
  displayName: PropTypes.string,
  store: PropTypes.object,
};

export default TegelGenreBanner;
